import React from 'react';

// Renders the small, controlled markdown subset the report prompt is
// instructed to use: plain paragraphs with occasional **bold**, and a
// numbered action-item list ("1. **Lead-in.** Explanation."). Not a general
// markdown parser — the prompt's output shape is fully in our control, so a
// tiny hand-written renderer covers it without adding a dependency.

function renderInline(text: string, keyPrefix: string): React.ReactNode[] {
  const parts = text.split(/(\*\*[^*]+\*\*)/g).filter((part) => part.length > 0);
  return parts.map((part, i) =>
    part.startsWith('**') && part.endsWith('**') ? (
      <strong key={`${keyPrefix}-${i}`}>{part.slice(2, -2)}</strong>
    ) : (
      <React.Fragment key={`${keyPrefix}-${i}`}>{part}</React.Fragment>
    )
  );
}

export default function ReportText({ text }: { text: string }) {
  const lines = text.split('\n').filter((line) => line.trim().length > 0);
  const blocks: React.ReactNode[] = [];
  let listItems: React.ReactNode[] = [];

  function flushList() {
    if (listItems.length === 0) return;
    blocks.push(
      <ol className="dashboard__report-list" key={`list-${blocks.length}`}>
        {listItems}
      </ol>
    );
    listItems = [];
  }

  lines.forEach((rawLine, i) => {
    const line = rawLine.trim();
    const match = /^\d+\.\s+(.*)$/.exec(line);
    if (match) {
      listItems.push(<li key={`li-${i}`}>{renderInline(match[1], `li-${i}`)}</li>);
    } else {
      flushList();
      blocks.push(<p key={`p-${i}`}>{renderInline(line, `p-${i}`)}</p>);
    }
  });
  flushList();

  return <div className="dashboard__report-text">{blocks}</div>;
}
